import React, { useEffect } from 'react';
import './SetRadiusArea.scss';
import { GoogleMap, useJsApiLoader, Circle, Marker } from '@react-google-maps/api';
import { Button } from '../../../../Components/StyledComponents';
import {cloneDeep} from 'lodash-es';

const SetRadiusArea = ({radiusInfo, patchAreaRadius, center}) => {
    const [ radius, setRadius] = React.useState(1000);
    const [ zoom, setZoom ] = React.useState(13);

    useEffect(() => {
        if( typeof radiusInfo !== 'undefined') setRadius(cloneDeep(radiusInfo));
    },[])

    useEffect(() => {
        if(radius <= 1000){
            setZoom(15)
        }else if( radius <= 1500 ){
            setZoom(14)
        }else if( radius <= 3200 ){
            setZoom(13)
        }else {
            setZoom(12)
        }
    },[radius])

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: "AIzaSyC0PMPir5JCgWEtYAQIrbk0ej72UlQ-1wY"
    })

    const options = {
        strokeColor: '#f95f53',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#f65f53',
        fillOpacity: 0.35,
        clickable: false,
        draggable: false,
        editable: false,
        visible: true,
        zIndex: 1
    }
    //반경은 최소 100m 부터 최대 2km 까지
    const handleRadius = (val) => {
        if(radius + val > 0 && radius + val <= 2000){
            setRadius(old => old + val)
        }else return
    }

    const patch = () => {
        patchAreaRadius(radius)
    }

    return(
        <div className='set-delivery-area'>
            <div style={{ width : 720, height : 400 }}>
                {
                    isLoaded &&
                    <GoogleMap
                        center={center}
                        zoom={zoom}
                        mapContainerStyle={{ width : 720, height : 400 }}
                    >
                        <Circle
                            center={center}
                            radius={radius}
                            options={options}
                        />
                        <Marker
                            position={center}
                        />
                        <></>
                    </GoogleMap>
                }
            </div>
            <div className='row between' style={{ marginTop : 36 }}>
                <p className='area-text'>해당 반경 내의 사용자만 주문이 가능합니다. ( 최소 : 0.1Km, 최대 : 2Km )</p>
                <div className='row'>
                    <Button variant='sub' className='minus-btn' style={{ width : 32, height : 32, textAlign : 'center', borderRadius : 100, padidngLeft : 0, margin : 0 }} disabled={radius === 100} onClick={() => handleRadius(-100)}>
                        <img src={require('../../../../aseets/icons/minus_pink.svg').default} style={{ width : 24, height : 24 }} />
                    </Button>
                    <p className='area-distance'>{(radius/1000).toFixed(1)}km</p>
                    <Button variant='sub' className='minus-btn' style={{ width : 32, height : 32, textAlign : 'center', borderRadius : 100 }} disabled={ radius === 2000 } onClick={() => handleRadius(100)}>
                        <img src={require('../../../../aseets/icons/plus_pink.svg').default} style={{ width : 24, height : 24 }} />
                    </Button>
                </div>
            </div>
            <div className='btn-row'>
                <Button variant="main" className='save-btn' fontSize={16} onClick={() => patch()}>
                    저장하기
                </Button>
            </div>
        </div>
    )
}

export default SetRadiusArea;